import React from "react";

import { Helmet } from "react-helmet";
export default function CustomHelmet({ page, canonical }) {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{page} | Hubsquares</title>
      <link rel="canonical" href="https://hubsquares.com" />
    </Helmet>
  );
}
